/* eslint-disable react/display-name */
import { ErrorMessage } from '@hookform/error-message';
import { Tooltip } from '@material-ui/core';
import Select from 'react-select';
import { custom_select } from 'assets/styles/multiple_select';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState
} from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Button, Col, Form, Input, Row, FormGroup, Label } from 'reactstrap';
import xlsxImage from '../../../../../assets/img/xlsx.png';
import pdfImage from '../../../../../assets/img/pdf.png';
import {
  ImageButton,
  ImageButtonConteinerProtocol,
  ImageSize
} from '../../../../../assets/styles/image_style';
import DatePicker from '../../../../../components/Inputs/DatePicker';
import { useListReasonByRecordType } from '../../../../reason/list/hooks/useListReasonByRecordType';
import { useUsers } from '../../../../Report/Protocol/hooks/useUsers';
import { useListStatusByRecordType } from '../../../../status/list/hooks/useListStatusByRecordType';
import { functionsUseFul } from '../../assets/functionsUseFul';
import { ErrorFormMessage } from '../ErrorFormMessage';
import FlexSelect from 'components/Inputs/FlexSelect';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import AdvancedSearch from 'views/Report/Protocol/Analytical/components/AdvancedSearchForm';
import { useProtocolFieldsByRecordType } from 'views/fieldConfigs/hooks/useProtocolFieldsByRecordType';
import { UserFlexSelect } from '../../../../../components/UserFlexSelect';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { ItemPerPageSelect } from '../../../../../components/Inputs/ItemPerPageSelect';
import { useMultipleSubReason } from 'views/Report/Protocol/hooks/useMultipleSubReason';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';
import SelectAccount from 'react-select/async';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import channels from 'variables/channels';
import { toast } from 'react-toastify';
import ProtocolService from '../../../../Protocol/service';
import ModelUpdateMultProtocols from 'views/Protocol/updateForm/components/ModalUpdateMultProtocols';
import MatrixSLAService from '../../../../SLA/MatrixSLA/service';
import { FlexSelectSearchTag } from 'components/Inputs/SelectWithSearch';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from '../../../../../hooks/useMemorizeInputsFilters';
import formattedTags from '../../utils/formattedTags';
import ServiceChannelService from '../../../../ServiceChannel/service';
const KANBAN_PREFERENCE_KEY = 'crm::kanban_preference_protocol';

// eslint-disable-next-line react/display-name
const FiltersForm = React.forwardRef(
  (
    {
      defaultFields,
      handleGetProtocols,
      handleGetProtocolsOverallSLAInfo,
      canSeeAllProtocols,
      dateRules,
      getMediaPath,
      quantity,
      recordTypes,
      selectedRecordType,
      handleSelectedRecordTypeChange,
      isPageReloaded = false,
      isListenerOnRecordType = false,
      setIsListenerOnRecordType,
      setShowTable = () => {},
      showTable = 'TABLE',
      setActivePage = () => {},
      sortOrder,
      orderByFilter,
      activePage,
      itemsPerPage,
      setItemsPerPage,
      typeReportSelected,
      setTypeReportSelected,
      setDataGrafics,
      setLoaderGrafics,
      ids,
      hasChangedRecordType,
      setHasChangedRecordType,
      callBackShowAdvancedFilters = () => {},
      isRecordTypeUsingSLA,
      onSelectedRowsChange = () => {},
      dataField = null,
      // eslint-disable-next-line no-unused-vars
      onlySubprotocols,
      setOnlySubprotocols
    },
    ref
  ) => {
    const {
      control,
      handleSubmit,
      getValues,
      setValue,
      errors,
      register,
      reset,
      watch
    } = useForm();

    const typesReports = ['Analítico', 'Sintético'];
    const modifyReportSelected = (param) => {
      setTypeReportSelected(param.target.value);
    };
    const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
      useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.PROTOCOL);
    const [showDateIntervalForm, setShowDateIntervalForm] = useState(true);
    const [usersShowDisable, setUsersShowDisable] = useState(true);
    const { userList } = useUsers(usersShowDisable);

    const updatedUsersList = useMemo(() => {
      const mappedUsers = userList ? userList : [];
      return [
        ...mappedUsers,
        { name: 'Sem responsável', login: 'sem_responsavel' }
      ];
    }, [userList]);

    const { status, getStatusByRecordType } = useListStatusByRecordType(
      selectedRecordType.value
    );

    const { reasons, getReasonsByRecordType } = useListReasonByRecordType(
      selectedRecordType.value
    );
    const { subreasons, loadingSubreasons, handleGetSubReasons } =
      useMultipleSubReason();

    const getSelectedRecordTypeId = () => {
      return selectedRecordType.value;
    };
    const { protocolCustomFields } = useProtocolFieldsByRecordType(
      getSelectedRecordTypeId()
    );

    const [filtersProtocol, setFiltersProtocol] = useState({});
    const [openModalUpdateMultProtocols, setOpenModalUpdateMultProtocols] =
      useState(false);
    const [showAdvancedSearchForm, setShowAdvancedSearchForm] = useState(false);
    const [hasLoadedMemorizedFilters, setHasLoadedMemorizedFilters] =
      useState(false);
    const systemConfiguration = useSelector(
      (state) => state.systemConfiguration
    );
    const {
      getDateBegin,
      disabledDownloadButtonCsvAndPdf,
      definedMessageGeneratedInPdfCsvDownloads
    } = functionsUseFul();
    const limitGenerationPDF = parseInt(
      process.env.REACT_APP_LIMIT_GENERATION_PDF || 25000
    );
    const [messagemGeneratePdf, setMessagemGeneratePdf] = useState();
    const [messagemGenerateCsv, setMessagemGenerateCsv] = useState();
    const [areDefaultFiltersSet, setAreDefaultFiltersSet] = useState(false);

    const defaultPageAndSize = { page: 1, size: itemsPerPage };
    const { isSearching, filterAccounts } = useSearchAccounts();
    const [account, setAccount] = useState();

    const [canalOptions, setCanalOptions] = useState([]);

    const [serviceChannelOptions, setServiceChannelOptions] = useState([]);

    const [slaOptions, setSlaOptions] = useState([]);

    const [impacts, setImpacts] = useState([]);
    const [criticalities, setCriticalities] = useState([]);

    const limitGenerationXLSX = 40000;

    const watchedValues = watch();

    const readStatusOptions = [
      { label: 'Ambos', value: '' },
      { label: 'Lidos', value: 'read' },
      { label: 'Não Lidos', value: 'unread' }
    ];

    function usePersistedState(key, initialValue) {
      const [state, setState] = useState(() => {
        const stored = localStorage.getItem(key);
        if (stored === null) return initialValue;

        try {
          return JSON.parse(stored);
        } catch {
          return stored;
        }
      });

      useEffect(() => {
        if (state === undefined || state === null) return;

        const value = typeof state === 'string' ? state : JSON.stringify(state);

        localStorage.setItem(key, value);
      }, [key, state]);

      return [state, setState];
    }

    const [persistedResponsible, setPersistedResponsible] = usePersistedState(
      'persistedResponsible',
      []
    );

    const [persistedReason, setPersistedReason] = usePersistedState(
      'persistedReason',
      []
    );

    const [persistedSubreason, setPersistedSubreason] = usePersistedState(
      'persistedSubreason',
      []
    );

    const [persistedServiceChannel, setPersistedServiceChannel] =
      usePersistedState('persistedServiceChannel', []);

    const [persistedStatusPhase, setpersistedStatusPhase] = usePersistedState(
      'persistedStatusPhase',
      []
    );

    const [persistedChannel, setPersistedChannel] = usePersistedState(
      'persistedChannel',
      []
    );

    const [persistedReadStatus, setPersistedReadStatus] = useState(
      readStatusOptions[0]
    );

    const [persistedAccount, setPersistedAccount] = usePersistedState(
      'persistedAccount',
      null
    );

    const [persistedTags, setPersistedTags] = usePersistedState(
      'persistedTags',
      []
    );

    const [persistedContact, setPersistedContact] = usePersistedState(
      'persistedContact',
      ''
    );

    const [persistedDateBegin, setPersistedDateBegin] = usePersistedState(
      'persistedDateBegin',
      null
    );

    const [persistedDateEnd, setPersistedDateEnd] = usePersistedState(
      'persistedDateEnd',
      null
    );

    const [persistedProtocolText, setPersistedProtocolText] = usePersistedState(
      'persistedProtocolText',
      ''
    );

    const [persistedSLAStatus, setPersistedSLAStatus] = usePersistedState(
      'persistedSLAStatus',
      []
    );

    const [persistedSLASolutionStatus, setPersistedSLASolutionStatus] =
      usePersistedState('persistedSLASolutionStatus', []);

    const [persistedMatrixSLA, setPersistedMatrixSLA] = usePersistedState(
      'persistedMatrixSLA',
      []
    );

    const [persistedImpact, setPersistedImpact] = usePersistedState(
      'persistedImpact',
      []
    );

    const [persistedCri, setPersistedCri] = usePersistedState(
      'persistedCri',
      []
    );

    const getChannels = useCallback(() => {
      FlexChatIntegration.getAllChannels().then((res) => {
        const info = res.data.data;

        let array = [];

        channels.forEach((nome) => {
          if (!info[nome]) return;
          if (nome === 'whatsapp' || nome === 'webchat') {
            info[nome].forEach((item, index) => {
              array.push(info[nome][index] ?? []);
            });
            return;
          }
          array.push(info[nome] ?? []);
        });

        const list = array.map((canal) => {
          return { label: canal?.nome_canal, value: canal?.id };
        });

        setCanalOptions(list);
      });
    }, [channels]);

    const getServiceChannels = useCallback(() => {
      ServiceChannelService.getWithoutPagination()
        .then((res) => {
          const data = res.data;
          const list = (Array.isArray(data) ? data : []).map((canal) => ({
            label: canal.name,
            value: canal.key
          }));
          setServiceChannelOptions(list);
        })
        .catch((err) => {
          console.error('Erro ao buscar canais:', err);
        });
    }, []);

    const clearSelectedRows = () => {
      onSelectedRowsChange([]);
    };

    useEffect(() => {
      getStatusByRecordType();
    }, [getStatusByRecordType]);

    useEffect(() => {
      if (isPageReloaded === false && isListenerOnRecordType === true) {
        reset({
          reason_id: '',
          subreason_id: '',
          current_status: '',
          idChannel: '',
          current_responsible: '',
          service_channel: '',
          matrixSLA: '',
          impact: '',
          criticality: '',
          slaAtendimento: '',
          slaSolucao: '',
          tags: []
        });
      }
      setIsListenerOnRecordType(false);
    }, [handleSelectedRecordTypeChange]);

    useEffect(() => {
      getReasonsByRecordType();
    }, [getReasonsByRecordType]);

    useEffect(() => {
      getChannels();
    }, [getChannels]);

    useEffect(() => {
      getServiceChannels();
    }, [getServiceChannels]);

    useEffect(() => {
      const filters = getMemorizedFilters();

      const savedViewMode = localStorage.getItem(KANBAN_PREFERENCE_KEY);
      if (
        savedViewMode &&
        ['TABLE', 'KANBAN', 'SPLIT'].includes(savedViewMode)
      ) {
        setShowTable(savedViewMode);
      }

      if (filters?.selectedRecordType) {
        handleSelectedRecordTypeChange(filters.selectedRecordType, {
          isReloadPage: true,
          cleanMemorizedFilters: false
        });
      }
      if (filters?.reason_id) {
        handleGetSubReasons(filters.reason_id);
      }
      if (filters?.matrixSLA) {
        handleGetImpactsAndCriticalities(filters.matrixSLA.value);
      }
      if (filters?.account) {
        setAccount(filters.account);
      }

      if (filters) {
        reset(filters);
      }
      setAreDefaultFiltersSet(true);
      setShowDateIntervalForm(filters?.showDateIntervalForm || false);

      if (filters?.readStatusFilter) {
        const readStatusObj =
          typeof filters.readStatusFilter === 'object' &&
          filters.readStatusFilter?.value
            ? filters.readStatusFilter
            : handleMapReadStatus(filters.readStatusFilter);
        setPersistedReadStatus(readStatusObj);
      } else {
        const defaultOption = readStatusOptions[0];
        setPersistedReadStatus(defaultOption);
      }

      if (filters && protocolCustomFields && protocolCustomFields.length > 0) {
        const hasCustomFieldValues = protocolCustomFields.some((field) => {
          if (field.type === 'DATE') {
            return (
              filters[field.name + '.DateBegin'] ||
              filters[field.name + '.DateEnd']
            );
          }
          return (
            filters[field.name] !== undefined &&
            filters[field.name] !== '' &&
            filters[field.name] !== null &&
            !(
              Array.isArray(filters[field.name]) &&
              filters[field.name].length === 0
            )
          );
        });

        if (hasCustomFieldValues || filters.showAdvancedSearchForm) {
          setShowAdvancedSearchForm(true);
          callBackShowAdvancedFilters(true);
        }
      } else if (filters?.showAdvancedSearchForm) {
        setShowAdvancedSearchForm(true);
        callBackShowAdvancedFilters(true);
      }

      setHasLoadedMemorizedFilters(true);

      return () => handleSaveFilters();
    }, [getMemorizedFilters, reset]);

    useEffect(() => {
      if (
        hasLoadedMemorizedFilters &&
        protocolCustomFields &&
        protocolCustomFields.length > 0
      ) {
        const filters = getMemorizedFilters();

        if (filters) {
          setTimeout(() => {
            protocolCustomFields.forEach((field) => {
              if (field.type === 'DATE') {
                const dateBegin = filters[field.name + '.DateBegin'];
                const dateEnd = filters[field.name + '.DateEnd'];
                if (dateBegin) setValue(field.name + '.DateBegin', dateBegin);
                if (dateEnd) setValue(field.name + '.DateEnd', dateEnd);
              } else if (
                filters[field.name] !== undefined &&
                filters[field.name] !== '' &&
                filters[field.name] !== null
              ) {
                setValue(field.name, filters[field.name]);
              }
            });
          }, 500);
        }
      }
    }, [
      hasLoadedMemorizedFilters,
      protocolCustomFields,
      getMemorizedFilters,
      setValue,
      getValues
    ]);

    useEffect(() => {
      const message = definedMessageGeneratedInPdfCsvDownloads(
        quantity,
        limitGenerationPDF,
        limitGenerationXLSX,
        filtersProtocol
      );

      setMessagemGeneratePdf(message.pdfMessage);
      setMessagemGenerateCsv(message.xlsxMessage);
    }, [
      quantity,
      limitGenerationPDF,
      definedMessageGeneratedInPdfCsvDownloads,
      filtersProtocol
    ]);

    //------------sla----------------
    useEffect(() => {
      if (!isRecordTypeUsingSLA) return;
      MatrixSLAService.getWithoutPagination(false, selectedRecordType.value)
        .then((res) => {
          const data = res.data.data.content;
          const list = data.map((sla) => {
            return { label: sla.name, value: sla.id };
          });

          setSlaOptions(list);
        })
        .catch(() => {
          toast.error('Erro ao buscar Matrizes ', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }, [isRecordTypeUsingSLA, selectedRecordType]);

    const handleSaveFilters = useCallback(() => {
      const currentFilters = getMemorizedFilters();
      const page = currentFilters?.page ? currentFilters.page : 1;
      const size = currentFilters?.size ? currentFilters.size : itemsPerPage;

      setActivePage(page);

      if (areDefaultFiltersSet) {
        memorizeFilters({
          ...watchedValues,
          selectedRecordType,
          showDateIntervalForm,
          showAdvancedSearchForm,
          page,
          size,
          order_by: orderByFilter,
          order_type: sortOrder,
          account,
          viewMode: showTable
        });

        localStorage.setItem(KANBAN_PREFERENCE_KEY, showTable);
      }
    }, [
      setActivePage,
      areDefaultFiltersSet,
      memorizeFilters,
      watchedValues,
      selectedRecordType,
      showDateIntervalForm,
      showAdvancedSearchForm,
      itemsPerPage,
      orderByFilter,
      sortOrder,
      account,
      showTable
    ]);

    useEffect(() => {
      if (areDefaultFiltersSet) {
        handleSaveFilters();
      }
    }, [showTable]);

    const onSubmit = useCallback(
      async (dataSubmit) => {
        if (!selectedRecordType) return;

        const preparedData = prepareFiltersData(dataSubmit);

        if (account?.value) {
          preparedData.account_id = account?.value;
        }
        const dataDTO = formatCustomFieldsToSubmit(
          preparedData,
          protocolCustomFields ?? []
        );

        if (isRecordTypeUsingSLA) {
          handleGetProtocolsOverallSLAInfo(preparedData);
        }

        if (typeReportSelected === 'Analítico') {
          setFiltersProtocol(dataDTO);

          setActivePage(activePage);
          const dataToSubmitWithOrder = {
            ...preparedData,
            order_by: orderByFilter,
            order_type: sortOrder
          };
          if (showTable === 'TABLE' && !hasChangedRecordType) {
            const currentFilters = getMemorizedFilters();

            const readStatusToSave =
              typeof persistedReadStatus === 'object' &&
              persistedReadStatus?.value
                ? persistedReadStatus
                : handleMapReadStatus(
                    preparedData.readStatusFilter || persistedReadStatus
                  );

            const filtersToSave = {
              ...currentFilters,
              ...preparedData,
              page: defaultPageAndSize.page,
              size: defaultPageAndSize.size,
              order_by: orderByFilter,
              order_type: sortOrder,
              account,
              showDateIntervalForm,
              dateBegin: showDateIntervalForm
                ? preparedData.dateBegin
                : undefined,
              dateEnd: showDateIntervalForm ? preparedData.dateEnd : undefined,
              readStatusFilter: readStatusToSave
            };

            memorizeFilters(filtersToSave);
            if (Object.keys(preparedData).length > 0) {
              handleGetProtocols({
                ...dataToSubmitWithOrder,
                ...defaultPageAndSize,
                order_by: orderByFilter,
                order_type: sortOrder
              });
            }
            return;
          }
          if (showTable === 'KANBAN') {
            if (Object.keys(dataSubmit).length > 0) {
              handleGetProtocols(
                {
                  ...dataToSubmitWithOrder,
                  page: 1,
                  size: 20
                },
                false,
                true
              );
            }
            return;
          }
          if (showTable === 'SPLIT') {
            if (Object.keys(dataSubmit).length > 0) {
              handleGetProtocols(
                {
                  ...dataToSubmitWithOrder,
                  page: 1,
                  size: 30
                },
                false,
                false,
                true
              );
            }
            return;
          }
          handleGetProtocols(
            {
              ...dataSubmit,
              size: itemsPerPage,
              order_by: orderByFilter,
              order_type: sortOrder
            },
            false
          );
          return;
        } else {
          try {
            setLoaderGrafics(true);

            let dataToSend = {};
            Object.keys(dataDTO).forEach((key) => {
              if (dataDTO[key] === 0 || !!dataDTO[key]) {
                dataToSend[key] = dataDTO[key];
              }
            });

            if (dataToSend?.tags?.length > 0) {
              dataToSend = formattedTags(dataToSend);
            }

            const response = await ProtocolService.getReportProtocol(
              { ...dataToSend, recordType: selectedRecordType.value },
              'synthetic'
            );
            const responseData = response?.data.content;
            setDataGrafics({ ...responseData });

            setLoaderGrafics(false);
            //totalProtocolsPerStatus vai vir nulo quando o campo "status" do protocolo estiver desaivado
          } catch (err) {
            setLoaderGrafics(false);
            toast.error('Erro desconhecido por favor, informar o suporte!', {
              autoClose: 3000,
              closeOnClick: true
            });
          }
        }

        return;
      },
      [
        typeReportSelected,
        handleGetProtocols,
        orderByFilter,
        setActivePage,
        showTable,
        sortOrder,
        itemsPerPage,
        setDataGrafics,
        setLoaderGrafics,
        account?.value,
        hasChangedRecordType,
        showDateIntervalForm,
        prepareFiltersData
      ]
    );

    const toISOFormat = useCallback(async (dateTimeString, bar = false) => {
      const [date] = dateTimeString.split(' ');
      const [DD, MM, YYYY] = date.split('/');
      if (bar) return `${YYYY}/${MM}/${DD}`;
      return `${YYYY}-${MM}-${DD}`;
    }, []);

    const cleanFilters = () => {
      const dateBegin = getDateBegin();
      const dateEnd = new Date().toLocaleDateString('pt-br');

      reset({
        dateBegin,
        dateEnd,
        current_responsible: '',
        reason_id: [],
        subreason_id: [],
        status_id: '',
        current_status: [],
        protocolTextQuery: '',
        clientTextQuery: '',
        tags: [],
        readStatusFilter: '',
        idChannel: '',
        service_channel: [],
        matrixSLA: '',
        criticality: [],
        impact: [],
        slaAtendimento: '',
        slaSolucao: '',
        has_priority: false,
        onlySubprotocols: false,
        typeDateFilter: 'creation'
      });

      setAccount(null);
      setShowAdvancedSearchForm(false);
      callBackShowAdvancedFilters(false);
      setImpacts([]);
      setCriticalities([]);
      setOnlySubprotocols(false);
      setUsersShowDisable(true);
      setShowDateIntervalForm(false);

      setPersistedResponsible([]);
      setPersistedReason([]);
      setPersistedSubreason([]);
      setPersistedServiceChannel([]);
      setpersistedStatusPhase([]);
      setPersistedChannel([]);
      setPersistedReadStatus([]);
      setPersistedAccount(null);
      setPersistedTags([]);
      setPersistedContact('');
      setPersistedDateBegin(null);
      setPersistedDateEnd(null);
      setPersistedProtocolText('');
      setPersistedSLAStatus([]);
      setPersistedSLASolutionStatus([]);
      setPersistedMatrixSLA([]);
      setPersistedImpact([]);
      setPersistedCri([]);

      clearMemorizedFilters();

      setShowTable('TABLE');
      setActivePage(1);
      localStorage.removeItem(KANBAN_PREFERENCE_KEY);

      handleGetProtocols({
        typeDateFilter: 'creation',
        has_priority: false,
        onlySubprotocols: false,
        page: 1,
        size: itemsPerPage,
        order_by: orderByFilter,
        order_type: sortOrder
      });
    };

    useImperativeHandle(ref, () => ({
      cleanFilters() {
        cleanFilters();
      }
    }));

    const handleDownloadClick = async (fileType) => {
      const url = getMediaPath(fileType);
      const headers = {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        login: localStorage.getItem('login')
      };

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers
        });

        const result = await response.json();

        if (!response.ok) {
          toast.error(
            result.message || 'Ocorreu um erro ao iniciar a geração do arquivo.'
          );
          return;
        }

        toast.success(result.message);
      } catch (error) {
        console.error('Erro ao solicitar relatório:', error);
        toast.error(error.message);
      }
    };

    const getSelectOptionsDTO = () => {
      if (!recordTypes) return [];
      return recordTypes.map((group) => ({
        label: group.name,
        value: group.id
      }));
    };

    const handleGetImpactsAndCriticalities = useCallback(
      async (matrixSLAId) => {
        MatrixSLAService.listImpactsAndCriticalities(matrixSLAId)
          .then((res) => {
            const data = res.data.data;
            const impacts = data.impacts.map((impact) => ({
              label: impact.name,
              value: impact.id
            }));
            const criticalities = data.criticalities.map((criticality) => ({
              label: criticality.name,
              value: criticality.id
            }));

            setImpacts(impacts);
            setCriticalities(criticalities);
          })
          .catch((err) => {
            const { message } = err.response.data;
            toast.error(message, {
              autoClose: 3000,
              closeOnClick: true
            });
          });
      },
      []
    );

    const handleMatrixSLAChange = (value) => {
      if (value) {
        handleGetImpactsAndCriticalities(value.value);
      }
    };

    const handleMarkProtocolsAsReadUnread = async (
      shouldMarkAsRead,
      protocols
    ) => {
      if (!protocols?.length) {
        console.warn('No protocols provided to mark as read/unread.');
        return;
      }

      const userId = localStorage.getItem('login');
      if (!userId?.trim()) {
        toast.error(
          'Usuário não autenticado. Por favor, faça login novamente.'
        );
        return;
      }

      const serviceMethod = shouldMarkAsRead
        ? ProtocolService.markProtocolsCommentsAsRead
        : ProtocolService.markProtocolsCommentsAsUnread;

      const successMessage = shouldMarkAsRead
        ? 'Comentários dos protocolos selecionados foram marcados como lidos'
        : 'Comentários dos protocolos selecionados foram marcados como não lidos';

      try {
        await serviceMethod({ protocols, userId });
        toast.success(successMessage);
        clearSelectedRows();
        if (dataField) {
          await handleGetProtocols(
            {
              ...dataField,
              page: activePage,
              size: itemsPerPage
            },
            false
          );
        }
      } catch (error) {
        console.error('Error marking protocols:', error);
        toast.error(
          `Erro ao marcar comentários como ${
            shouldMarkAsRead ? 'lidos' : 'não lidos'
          }. Tente novamente.`
        );
      }
    };

    const allSelectedAreUnread = useMemo(
      () =>
        ids?.every((protocol) => protocol.has_unread_comments === true) &&
        ids?.length >= 2,
      [ids]
    );
    const allSelectedAreRead = useMemo(
      () =>
        ids?.every((protocol) => protocol.has_unread_comments === false) &&
        ids?.length >= 2,
      [ids]
    );

    const renderSelectReadOrUnreadButtons = useCallback(() => {
      if (ids.length === 0) {
        return null;
      }
      if (allSelectedAreRead) {
        return (
          <Button
            style={buttonStyle(systemConfiguration.primary_color)}
            size="sm"
            onClick={() =>
              handleMarkProtocolsAsReadUnread(
                false,
                ids.map((p) => p.id)
              )
            }
          >
            Marcar como não lido
          </Button>
        );
      }

      if (allSelectedAreUnread) {
        return (
          <Button
            style={buttonStyle(systemConfiguration.primary_color)}
            size="sm"
            onClick={() =>
              handleMarkProtocolsAsReadUnread(
                true,
                ids.map((p) => p.id)
              )
            }
          >
            Marcar como lido
          </Button>
        );
      }

      return null;
    }, [
      allSelectedAreRead,
      allSelectedAreUnread,
      systemConfiguration,
      handleMarkProtocolsAsReadUnread,
      ids
    ]);

    const handleMapReadStatus = (value) =>
      readStatusOptions.find((status) => status.value === value) ||
      readStatusOptions[0];

    const prepareFiltersData = useCallback(
      (dataSubmit) => {
        let preparedData = { ...dataSubmit };

        if (!preparedData.current_responsible && persistedResponsible.length) {
          preparedData.current_responsible = persistedResponsible;
        }
        if (!preparedData.reason_id && persistedReason.length) {
          preparedData.reason_id = persistedReason;
        }
        if (!preparedData.subreason_id && persistedSubreason.length) {
          preparedData.subreason_id = persistedSubreason;
        }
        if (!preparedData.service_channel && persistedServiceChannel.length) {
          preparedData.service_channel = persistedServiceChannel;
        }
        if ('readStatusFilter' in preparedData) {
          if (typeof preparedData.readStatusFilter === 'object') {
            preparedData.readStatusFilter = preparedData.readStatusFilter.value;
          }
        } else if (persistedReadStatus?.value !== undefined) {
          preparedData.readStatusFilter = persistedReadStatus.value;
        }

        if (!preparedData.idChannel && persistedChannel.length) {
          preparedData.idChannel = persistedChannel;
        }
        if (!preparedData.account && persistedAccount) {
          preparedData.account = persistedAccount;
        }
        if (!preparedData.tags && persistedTags.length) {
          preparedData.tags = persistedTags;
        }
        if (!preparedData.dateBegin && persistedDateBegin) {
          preparedData.dateBegin = persistedDateBegin;
        }
        if (!preparedData.dateEnd && persistedDateEnd) {
          preparedData.dateEnd = persistedDateEnd;
        }
        if (!preparedData.protocolTextQuery && persistedProtocolText) {
          preparedData.protocolTextQuery = persistedProtocolText;
        }
        if (!preparedData.clientTextQuery && persistedContact) {
          preparedData.clientTextQuery = persistedContact;
        }

        if (!preparedData.current_status && persistedStatusPhase) {
          preparedData.current_status = persistedStatusPhase;
        }

        if (!showDateIntervalForm) {
          delete preparedData.dateBegin;
          delete preparedData.dateEnd;
        }

        delete preparedData.showDateIntervalForm;
        delete preparedData.showAdvancedSearchForm;
        delete preparedData.selectedRecordType;
        delete preparedData.viewMode;
        delete preparedData.columnsOrder;
        delete preparedData.hiddenColumns;
        delete preparedData.recordTypeId;
        delete preparedData.showProtocolFilters;

        if (!preparedData.has_priority) {
          delete preparedData.has_priority;
        }

        if (!preparedData.sla_status && persistedSLAStatus.length) {
          preparedData.sla_status = persistedSLAStatus;
        }

        if (
          !preparedData.sla_solution_status &&
          persistedSLASolutionStatus.length
        ) {
          preparedData.sla_solution_status = persistedSLASolutionStatus;
        }

        if (!preparedData.matrixSLA && persistedMatrixSLA.length) {
          preparedData.matrixSLA = persistedMatrixSLA;
        }

        if (!preparedData.impact && persistedImpact.length) {
          preparedData.impact = persistedImpact;
        }

        if (!preparedData.criticality && persistedCri.length) {
          preparedData.criticality = persistedCri;
        }

        return preparedData;
      },
      [
        persistedResponsible,
        persistedReason,
        persistedSubreason,
        persistedServiceChannel,
        persistedReadStatus,
        persistedChannel,
        persistedAccount,
        persistedTags,
        persistedDateBegin,
        persistedDateEnd,
        persistedProtocolText,
        persistedContact,
        showDateIntervalForm,
        persistedStatusPhase,
        persistedSLAStatus,
        persistedSLASolutionStatus,
        persistedMatrixSLA,
        persistedImpact,
        persistedCri
      ]
    );

    return (
      defaultFields &&
      !!Object.keys(defaultFields).length && (
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Tipo de registro</label>
              <Select
                styles={custom_select}
                placeholder="Selecione..."
                options={getSelectOptionsDTO() || []}
                isSearchable={false}
                isClearable={false}
                name="recordType"
                defaultValue=""
                value={selectedRecordType}
                onChange={handleSelectedRecordTypeChange}
              />
            </Col>
            <Col md="6">
              <label className="form-control-label">Responsável atual</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={updatedUsersList}
                    isMulti={true}
                    isClearable={true}
                    value={persistedResponsible}
                    closeMenuOnSelect={true}
                    valueController={(fieldName, value) => {
                      setPersistedResponsible(value);
                      props.onChange(value);
                    }}
                    fieldName="current_responsible"
                    labelName="name"
                    valueName="login"
                  />
                )}
                disabled={!canSeeAllProtocols}
                control={control}
                name="current_responsible"
                defaultValue={persistedResponsible}
              />
            </Col>
          </Row>
          <Row className="mb-12">
            <Col className="md-12">
              <label
                className="form-control-label"
                style={{ marginLeft: '-15px' }}
              >
                <ToggleSwitch
                  id="showDateForm"
                  checked={showDateIntervalForm}
                  onChange={() => {
                    setShowDateIntervalForm(!showDateIntervalForm);
                  }}
                  default={showDateIntervalForm}
                />
                Buscar por data
              </label>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Data inicial</label>
              <Controller
                render={(props) => (
                  <DatePicker
                    fieldName="dateBegin"
                    valueController={(name, value) => {
                      setPersistedDateBegin(value);
                      setValue(name, value);
                    }}
                    defaultValue={props.value}
                    shouldDisable={!showDateIntervalForm}
                  />
                )}
                control={control}
                name="dateBegin"
                defaultValue={persistedDateBegin || getDateBegin()}
              />
              <ErrorMessage
                errors={errors}
                name="dateBegin"
                render={({ message }) => <ErrorFormMessage message={message} />}
              />
            </Col>
            <Col md="6">
              <label className="form-control-label">Data final</label>
              <Controller
                render={(props) => (
                  <DatePicker
                    fieldName="dateEnd"
                    valueController={(name, value) => {
                      setPersistedDateEnd(value);
                      setValue(name, value);
                    }}
                    defaultValue={props.value}
                    shouldDisable={!showDateIntervalForm}
                  />
                )}
                control={control}
                name="dateEnd"
                defaultValue={
                  showDateIntervalForm
                    ? persistedDateEnd
                    : persistedDateBegin || getDateBegin()
                }
                rules={{
                  ...dateRules,
                  validate: async (value) => {
                    if (
                      new Date(await toISOFormat(value, true)) <
                      new Date(
                        await toISOFormat(getValues()['dateBegin'], true)
                      )
                    ) {
                      return 'A data final não pode ser anterior à inicial!';
                    } else {
                      return true;
                    }
                  }
                }}
              />
              <ErrorMessage
                errors={errors}
                name="dateEnd"
                render={({ message }) => <ErrorFormMessage message={message} />}
              />
            </Col>
            <Col className="mt-2" md="6">
              <label
                className="form-control-label"
                style={{ marginRight: '20px', fontWeight: '400' }}
              >
                <input
                  type="radio"
                  name="typeDateFilter"
                  ref={register}
                  value="creation"
                  defaultChecked={true}
                />{' '}
                Data de criação
              </label>
              <label
                className="form-control-label"
                style={{ fontWeight: '400' }}
              >
                <input
                  type="radio"
                  name="typeDateFilter"
                  ref={register}
                  value="lastChange"
                  defaultChecked={false}
                  //disabled={isUpdate}
                />{' '}
                Data de última alteração
              </label>
            </Col>
          </Row>
          {typeReportSelected === 'Analítico' && (
            <Row className="mb-3">
              <Col
                md={
                  defaultFields?.client_id?.isActive
                    ? { size: 6 }
                    : { size: 12 }
                }
              >
                <label className="form-control-label">
                  Número do protocolo, email, título, descrição ou telefone
                </label>
                <Controller
                  control={control}
                  name="protocolTextQuery"
                  defaultValue={persistedProtocolText}
                  render={({ value, onChange }) => (
                    <Input
                      type="text"
                      placeholder="Buscar por número do protocolo, título, descrição e telefone"
                      value={value}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setPersistedProtocolText(e.target.value);
                      }}
                    />
                  )}
                />
              </Col>
              {defaultFields?.client_id?.isActive && (
                <Col md="6">
                  <label className="form-control-label">
                    Nome, email ou telefone do contato
                  </label>
                  <Controller
                    control={control}
                    name="clientTextQuery"
                    defaultValue={persistedContact}
                    render={({ value, onChange }) => (
                      <Input
                        type="text"
                        placeholder="Buscar por Nome, email e telefone do contato"
                        value={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setPersistedContact(e.target.value);
                        }}
                      />
                    )}
                  />
                </Col>
              )}
            </Row>
          )}

          <Row>
            {defaultFields?.reason_id?.isActive && (
              <Col className="mb-3" md="6">
                <label className="form-control-label">Motivo</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={
                        reasons
                          ? reasons.map(({ id, name }) => ({
                              label: name,
                              value: id
                            }))
                          : []
                      }
                      isMulti
                      value={persistedReason}
                      valueController={(fieldName, value) => {
                        setPersistedReason(value);
                        props.onChange(value);
                      }}
                      fieldName="reason_id"
                      labelName="label"
                      valueName="value"
                      isClearable={true}
                      onChange={(e) => {
                        handleGetSubReasons(e);

                        if (e.length === 0) {
                          setValue('subreason_id', []);
                        }
                      }}
                    />
                  )}
                  control={control}
                  name="reason_id"
                  defaultValue={[]}
                />
              </Col>
            )}
            {defaultFields?.subreason_id?.isActive && (
              <Col className="mb-3" md="6">
                <label className="form-control-label">Submotivo</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={
                        subreasons
                          ? subreasons.map(({ id, name }) => ({
                              label: name,
                              value: id
                            }))
                          : []
                      }
                      isMulti
                      value={persistedSubreason}
                      valueController={(fieldName, value) => {
                        setPersistedSubreason(value);
                        props.onChange(value);
                      }}
                      fieldName="subreason_id"
                      labelName="label"
                      valueName="value"
                      isClearable={true}
                    />
                  )}
                  disabled={loadingSubreasons}
                  control={control}
                  name="subreason_id"
                  defaultValue={[]}
                />
              </Col>
            )}
            {defaultFields?.current_status?.isActive && (
              <Col className="mb-3" md="6">
                <label className="form-control-label">Status/Fase</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={
                        status
                          ? status.map(({ id, name }) => ({
                              label: name,
                              value: id
                            }))
                          : []
                      }
                      isMulti
                      value={persistedStatusPhase}
                      valueController={(fieldName, value) => {
                        setpersistedStatusPhase(value);
                        props.onChange(value);
                      }}
                      fieldName="current_status"
                      labelName="label"
                      valueName="value"
                    />
                  )}
                  control={control}
                  name="current_status"
                  defaultValue={[]}
                />
              </Col>
            )}
            {defaultFields?.service_channel?.isActive && (
              <Col className="mb-3" md="6">
                <label className="form-control-label">
                  Canal de atendimento
                </label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={serviceChannelOptions}
                      value={persistedServiceChannel}
                      valueController={(fieldName, value) => {
                        setPersistedServiceChannel(value);
                        props.onChange(value);
                      }}
                      fieldName="service_channel"
                      labelName="label"
                      valueName="value"
                      placeholder="Selecione o canal"
                      isSearchable={false}
                      isMulti
                      isClearable
                    />
                  )}
                  control={control}
                  name="service_channel"
                  defaultValue=""
                />
              </Col>
            )}
          </Row>
          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Canal</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={canalOptions}
                    isMulti={false}
                    isClearable={true}
                    value={persistedChannel}
                    valueController={(fieldName, value) => {
                      setPersistedChannel(value);
                      props.onChange(value);
                    }}
                    closeMenuOnSelect={true}
                    fieldName="idChannel"
                    labelName="label"
                    valueName="value"
                  />
                )}
                control={control}
                name="idChannel"
                defaultValue=""
              />
            </Col>

            <Col md="6">
              <label className="form-control-label">Conta</label>
              <SelectAccount
                styles={custom_select}
                placeholder="Buscar por conta"
                isClearable={true}
                name="account_id"
                isLoading={isSearching}
                loadingMessage={() => 'Buscando...'}
                noOptionsMessage={({ inputValue }) =>
                  !inputValue
                    ? 'Digite para pesquisar'
                    : 'Nenhum resultado encontrado'
                }
                loadOptions={async (inputValue) => {
                  const res = await filterAccounts(inputValue);
                  return (
                    res &&
                    res.map((account) => ({
                      label: account.name,
                      value: account.id
                    }))
                  );
                }}
                onChange={(data) => {
                  if (data) {
                    const accountData = {
                      label: data.label,
                      value: data.value
                    };
                    setAccount(accountData);
                    setPersistedAccount(accountData);
                  } else {
                    setAccount(null);
                    setPersistedAccount(null);
                  }
                }}
                value={
                  account
                    ? {
                        label: account.label,
                        value: account.value
                      }
                    : ''
                }
                defaultValue={
                  account
                    ? {
                        label: account.label,
                        value: account.value
                      }
                    : ''
                }
              />
            </Col>
          </Row>

          {isRecordTypeUsingSLA && (
            <>
              <Row className="mb-3">
                <Col md="6">
                  <label className="form-control-label">Matriz SLA</label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Selecione..."
                        options={slaOptions || []}
                        isClearable={true}
                        value={persistedMatrixSLA}
                        onChange={(value) => {
                          if (!value) {
                            setPersistedMatrixSLA([]);
                            setImpacts([]);
                            setCriticalities([]);
                          } else {
                            setPersistedMatrixSLA(value);
                            handleGetImpactsAndCriticalities(value.value);
                          }
                          props.onChange(value);
                        }}
                      />
                    )}
                    control={control}
                    name="matrixSLA"
                    defaultValue={persistedMatrixSLA}
                  />
                </Col>
                <Col md="3">
                  <label className="form-control-label">Criticidade</label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Selecione..."
                        options={criticalities || []}
                        isClearable={true}
                        isMulti={true}
                        value={persistedCri}
                        onChange={(value) => {
                          if (!value) {
                            setPersistedCri([]);
                          } else {
                            setPersistedCri(value);
                          }
                          props.onChange(value);
                        }}
                      />
                    )}
                    control={control}
                    name="criticality"
                    defaultValue={persistedCri}
                  />
                </Col>
                <Col md="3">
                  <label className="form-control-label">Impacto</label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Selecione..."
                        options={impacts || []}
                        isClearable={true}
                        isMulti={true}
                        value={persistedImpact}
                        onChange={(value) => {
                          if (!value) {
                            setPersistedImpact([]);
                          } else {
                            setPersistedImpact(value);
                          }
                          props.onChange(value);
                        }}
                      />
                    )}
                    control={control}
                    name="impact"
                    defaultValue={persistedImpact}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <label className="form-control-label">
                    Status do SLA de Atendimento
                  </label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Selecione..."
                        options={[
                          { value: 1, label: 'Vencido' },
                          { value: 2, label: 'Não Vencido' }
                        ]}
                        isClearable={true}
                        value={persistedSLAStatus}
                        onChange={(value) => {
                          if (!value) {
                            setPersistedSLAStatus([]);
                          } else {
                            setPersistedSLAStatus(value);
                          }
                          props.onChange(value);
                        }}
                      />
                    )}
                    control={control}
                    name="slaAtendimento"
                    defaultValue={persistedSLAStatus}
                  />
                </Col>
                <Col md="6">
                  <label className="form-control-label">
                    Status do SLA de solução
                  </label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Selecione..."
                        options={[
                          { value: 1, label: 'Vencido' },
                          { value: 2, label: 'Não Vencido' }
                        ]}
                        isClearable={true}
                        value={persistedSLASolutionStatus}
                        onChange={(value) => {
                          if (!value) {
                            setPersistedSLASolutionStatus([]);
                          } else {
                            setPersistedSLASolutionStatus(value);
                          }
                          props.onChange(value);
                        }}
                      />
                    )}
                    control={control}
                    name="slaSolucao"
                    defaultValue={persistedSLASolutionStatus}
                  />
                </Col>
              </Row>
            </>
          )}
          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Tipo de visualização</label>
              <Input
                type="select"
                onChange={(e) => modifyReportSelected(e)}
                name="select"
                defaultValue={'Analítico'}
              >
                {typesReports.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md="6">
              <Controller
                render={(props) => (
                  <FlexSelectSearchTag
                    isMulti
                    value={persistedTags}
                    setValueSelected={(data) => {
                      setPersistedTags(data);
                      setValue('tags', data);
                    }}
                  />
                )}
                control={control}
                name="tags"
                defaultValue={persistedTags}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Status de leitura</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    dataOptions={readStatusOptions}
                    isMulti={false}
                    value={persistedReadStatus}
                    valueController={(fieldName, value) => {
                      setPersistedReadStatus(value);
                      props.onChange(value);
                    }}
                    closeMenuOnSelect={true}
                    fieldName="readStatusFilter"
                    labelName="label"
                    valueName="value"
                    isClearable={false}
                  />
                )}
                control={control}
                name="readStatusFilter"
              />
            </Col>
          </Row>

          <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
            <UserFlexSelect
              usersShowDisable={usersShowDisable}
              setUsersShowDisable={setUsersShowDisable}
              name={'Responsável Atual'}
            />
            <Controller
              name="has_priority"
              control={control}
              defaultValue={getMemorizedFilters()?.has_priority ?? false}
              render={({ value, onChange }) => (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      id="has_priority"
                      checked={value}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                    <span style={{ fontSize: '0.875rem' }}>
                      Mostrar apenas protocolos prioritários
                    </span>
                  </Label>
                </FormGroup>
              )}
            />
            <Controller
              name="onlySubprotocols"
              control={control}
              defaultValue={getMemorizedFilters()?.onlySubprotocols ?? false}
              render={({ value, onChange }) => (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      id="only_subprotocols"
                      checked={value}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        onChange(checked);
                        setOnlySubprotocols(checked);
                      }}
                    />
                    <span style={{ fontSize: '0.875rem' }}>
                      Exibir apenas subprotocolos
                    </span>
                  </Label>
                </FormGroup>
              )}
            />
            {typeReportSelected !== 'Analítico' && (
              <>
                <Row className="mb-12">
                  <Col className="md-6 mx-4">
                    <Controller
                      name="enableCustomFields"
                      control={control}
                      render={(props) => (
                        <>
                          <label className="form-control-label">
                            <Input
                              type="checkbox"
                              onChange={(e) => props.onChange(e.target.checked)}
                              checked={props.value}
                            />
                            Mostrar gráficos de campos customizados
                          </label>
                        </>
                      )}
                      defaultValue={false}
                    />
                  </Col>
                </Row>
              </>
            )}
          </div>
          {typeReportSelected === 'Analítico' && (
            <Row className="mb-12">
              <Col className="md-12">
                <label
                  className="form-control-label"
                  style={{ marginLeft: '-15px' }}
                >
                  <ToggleSwitch
                    checked={showAdvancedSearchForm}
                    id="customFieldsAdvancedSearchForm"
                    onChange={() => {
                      setShowAdvancedSearchForm(!showAdvancedSearchForm);
                      callBackShowAdvancedFilters(!showAdvancedSearchForm);
                    }}
                  />
                  Busca avançada
                </label>
              </Col>
            </Row>
          )}
          {showAdvancedSearchForm && typeReportSelected === 'Analítico' && (
            <Row>
              <AdvancedSearch
                customFields={protocolCustomFields}
                control={control}
                setValue={setValue}
                error={errors}
                getValues={getValues}
                watch={watch}
                toISOFormat={toISOFormat}
              />
            </Row>
          )}

          <div className="mt-3" style={ImageButtonConteinerProtocol}>
            <Row>
              <Button
                style={buttonStyle(systemConfiguration.primary_color)}
                type="submit"
                size="sm"
                onClick={() => {
                  handleSaveFilters();
                  setHasChangedRecordType(false);
                }}
              >
                Filtrar protocolos
              </Button>
              <Col>
                <ItemPerPageSelect
                  valueController={setItemsPerPage}
                  entity={POSSIBLE_FILTERS_ENTITIES.PROTOCOL}
                ></ItemPerPageSelect>
              </Col>
              <Button
                style={{
                  backgroundColor: ids.length > 0 ? null : 'rgba(0, 0, 0, 0.5)',
                  opacity: ids.length > 0 ? null : '0.5',
                  cursor: ids.length > 0 ? 'pointer' : 'not-allowed'
                }}
                title="Atualizar protocolos em lote"
                size="md"
                color="info"
                disabled={ids.length > 0 ? false : true}
                onClick={() => setOpenModalUpdateMultProtocols(true)}
              >
                <li className="fas fa-user-edit"></li>
              </Button>

              {ids.length > 0 && renderSelectReadOrUnreadButtons()}
            </Row>

            {typeReportSelected === 'Analítico' && (
              <div>
                <label
                  style={{ fontWeight: '400' }}
                  className="form-control-label"
                >
                  <input
                    style={{ marginLeft: '11px' }}
                    checked={showTable === 'KANBAN'}
                    onChange={() => {
                      setShowTable((prev) => {
                        const formData = prepareFiltersData(getValues());
                        if (prev === 'SPLIT') {
                          handleGetProtocols(
                            {
                              ...formData,
                              order_by: orderByFilter,
                              order_type: sortOrder
                            },
                            false,
                            true
                          );
                          return 'KANBAN';
                        }

                        if (prev === 'KANBAN') {
                          handleGetProtocols({
                            ...formData,
                            order_by: orderByFilter,
                            order_type: sortOrder
                          });
                          return 'TABLE';
                        } else {
                          handleGetProtocols(
                            {
                              ...formData,
                              order_by: orderByFilter,
                              order_type: sortOrder
                            },
                            false,
                            true
                          );
                          return 'KANBAN';
                        }
                      });
                    }}
                    type="checkbox"
                  ></input>{' '}
                  Kanban
                </label>
                <label
                  style={{ fontWeight: '400' }}
                  className="form-control-label"
                >
                  <input
                    style={{ arginLeft: '11px' }}
                    checked={showTable === 'SPLIT'}
                    onChange={() => {
                      setShowTable((prev) => {
                        const formData = prepareFiltersData(getValues());
                        if (prev === 'KANBAN') {
                          handleGetProtocols(
                            {
                              ...formData,
                              order_by: orderByFilter,
                              order_type: sortOrder
                            },
                            false,
                            false,
                            true
                          );

                          return 'SPLIT';
                        }
                        if (prev === 'SPLIT') {
                          handleGetProtocols({
                            ...formData,
                            order_by: orderByFilter,
                            order_type: sortOrder
                          });
                          return 'TABLE';
                        } else {
                          handleGetProtocols(
                            {
                              ...formData,
                              order_by: orderByFilter,
                              order_type: sortOrder
                            },
                            false,
                            false,
                            true
                          );
                        }
                        return 'SPLIT';
                      });
                    }}
                    type="checkbox"
                  ></input>{' '}
                  Separar por status
                </label>
                <a
                  type="button"
                  disabled={disabledDownloadButtonCsvAndPdf(
                    'xlsx',
                    quantity,
                    limitGenerationPDF,
                    filtersProtocol
                  )}
                  style={ImageButton}
                  onClick={() => {
                    if (quantity <= limitGenerationXLSX) {
                      handleDownloadClick('xlsx');
                    } else {
                      handleDownloadClick('csv');
                    }
                  }}
                >
                  <Tooltip
                    title={
                      <p style={{ fontSize: '14px' }}>{messagemGenerateCsv}</p>
                    }
                    arrow
                  >
                    <img src={xlsxImage} alt="csv" style={ImageSize} />
                  </Tooltip>
                </a>
                <ModelUpdateMultProtocols
                  getProtocols={handleGetProtocols}
                  isModalOpen={openModalUpdateMultProtocols}
                  selectedRecordType={selectedRecordType}
                  onModalToggle={setOpenModalUpdateMultProtocols}
                  ids={ids}
                  selectedRecordTypeId={selectedRecordType}
                  onClearSelectedRows={clearSelectedRows}
                  isRecordTypeUsingSLA={isRecordTypeUsingSLA}
                />
                <button
                  type="button"
                  disabled={disabledDownloadButtonCsvAndPdf(
                    'pdf',
                    quantity,
                    limitGenerationPDF,
                    filtersProtocol
                  )}
                  style={ImageButton}
                  onClick={() => handleDownloadClick('pdf')}
                >
                  <Tooltip
                    title={
                      <p style={{ fontSize: '14px' }}>{messagemGeneratePdf}</p>
                    }
                    arrow
                  >
                    <img src={pdfImage} alt="pdf" style={ImageSize} />
                  </Tooltip>
                </button>
                <div>
                  <div style={{ fontSize: 'small', float: 'right' }}>
                    {quantity} resultado(s) encontrado(s)
                  </div>
                </div>
              </div>
            )}
          </div>
        </Form>
      )
    );
  }
);

export default FiltersForm;
